<!-- Modal (Imagens) -->

<ng-template #imagens let-modal>
  <div class="modal-header pl-3">
    <h3 class="modal-title" id="titulo-imagens"><b>Imagens</b></h3>

    <button class="close" type="button" aria-label="Close" (click)="modal.dismiss('Fechar')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="d-flex flex-wrap justify-content-center">
      @for (visitaImagem of visitasImagens; track visitaImagem) {
        <div class="pb-2">
          <img class="imagem" [src]="visitaImagem.nm_arquivo" alt="Imagem" />
        </div>
      }
    </div>
  </div>

  <div class="modal-footer flex-wrap">
    <button class="btn btn-success btn_formulario" type="button" (click)="modal.close('Ok')">Ok</button>
  </div>
</ng-template>

<!-- Modal (Rotas) -->

<ng-template #rotas let-modal>
  <div class="modal-header pl-3">
    <h3 class="modal-title" id="titulo-rotas"><b>Rotas</b></h3>

    <button class="close" type="button" aria-label="Close" (click)="modal.dismiss('Fechar')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body p-0">
    <google-map [center]="{lat: latitudeFoco, lng: longitudeFoco}" class="mapa" height="85vh" width="100%" [zoom]="zoom" mapTypeId="satellite" (mapInitialized)="onMapaRotasReady($event)" (mapClick)="adicionarMarcador($event.latLng.lat(), $event.latLng.lng())">
      <map-marker [position]="{lat: mapaRotas[0].origin.lat, lng: mapaRotas[0].origin.lng}" [options]="{icon: mapaRotas[0].markerOptions.origin.icon}"></map-marker>
      <map-marker [position]="{lat: mapaRotas[0].destination.lat, lng: mapaRotas[0].destination.lng}" [options]="{icon: mapaRotas[0].markerOptions.destination.icon}"></map-marker>
    </google-map>
  </div>

  <div class="modal-footer flex-wrap">
    <button class="btn btn-success btn_formulario" type="button" (click)="modal.close('Ok')">Ok</button>
  </div>
</ng-template>

@if (!carregando) {
  <div class="container-fluid p-0" [@esvanecerDesvanecer]="'in'">
    <!-- Título -->
    <div class="borda_inferior bg-light pt-3 pr-4 pb-3 pl-4">
      <div class="titulo_texto">Dashboard - Visitas ({{ hoje ? "Hoje" : "30 Dias" }})</div>
    </div>
    <!-- Filtro -->
    @if (!hoje) {
      <div class="pt-3 pr-4 pb-0 pl-4">
        <form [formGroup]="formFiltro" (ngSubmit)="filtrar()">
          <div class="form-row">
            <!-- Período -->
            <div class="form-group col-sm-2">
              <label class="text-secondary"><b>Dt. Inicial:</b></label>
              <input class="form-control form-control-sm" type="text" name="filtrar_dt_inicial" ngbDatepicker #dt_inicial="ngbDatepicker" (click)="dt_inicial.toggle()" formControlName="dt_inicial" />
            </div>
            <div class="form-group col-sm-2">
              <label class="text-secondary"><b>Dt. Final:</b></label>
              <input class="form-control form-control-sm" type="text" name="filtrar_dt_final" ngbDatepicker #dt_final="ngbDatepicker" (click)="dt_final.toggle()" formControlName="dt_final" />
            </div>
            <!-- Resultado -->
            <div class="form-group col-sm-3">
              <label class="text-secondary"><b>Resultado:</b></label>
              <input class="form-control form-control-sm" type="text" name="filtrar_resultado" formControlName="resultado" />
            </div>
            <!-- Vendedor(a) -->
            <div class="form-group col-sm-3">
              <label class="text-secondary"><b>Vendedor(a):</b></label>
              <input class="form-control form-control-sm" type="text" name="filtrar_vendedor" formControlName="vendedor" />
            </div>
            <div class="col-sm-2">
              <button class="btn btn-secondary btn_filtro" type="submit">Filtrar</button>
              @if (filtrado) {
                <button class="btn btn-secondary btn_filtro" type="button" (click)="removerFiltros()">Cancelar</button>
              }
            </div>
          </div>
        </form>
        <hr class="mt-2 mb-2" />
      </div>
    }
    <div class="pt-2 pr-4 pb-4 pl-4">
      <div class="d-flex flex-wrap align-content-center justify-content-center">
        <!-- Qtde Visitas -->
        <div class="quadros_numeros_sm p-2">
          <div class="d-flex align-items-center">
            <div class="pl-2 pr-2">
              <i class="fa fa-exchange quadros_numeros_icones"></i>
            </div>
            <div class="quadros_numeros_textos">
              {{ qtdeVisitas }}<br />Qtde Visitas
            </div>
          </div>
        </div>
        <!-- Em Rota -->
        <div class="quadros_numeros_sm p-2">
          <div class="d-flex align-items-center">
            <div class="pl-2 pr-2">
              <i class="fa fa-map-marker quadros_numeros_icones"></i>
            </div>
            <div class="quadros_numeros_textos">
              {{ qtdeEmRota }}<br />Em Rota
            </div>
            <div class="quadros_numeros_porcentagem">
              {{ porcentagemEmRota | currency: 'BRL' : '' }}%
            </div>
          </div>
        </div>
        <!-- Fora de Rota -->
        <div class="quadros_numeros_sm p-2">
          <div class="d-flex align-items-center">
            <div class="pl-2 pr-2">
              <i class="fa fa-map quadros_numeros_icones"></i>
            </div>
            <div class="quadros_numeros_textos">
              {{ qtdeForaRota }}<br />Fora de Rota
            </div>
            <div class="quadros_numeros_porcentagem">
              {{ porcentagemForaRota | currency: 'BRL' : '' }}%
            </div>
          </div>
        </div>
        <!-- Pedidos (Qtde) -->
        <div class="quadros_numeros_sm p-2">
          <div class="d-flex align-items-center">
            <div class="pl-2 pr-2">
              <i class="fa fa-shopping-cart quadros_numeros_icones"></i>
            </div>
            <div class="quadros_numeros_textos">
              {{ qtdePedidos }}<br />Qtde Pedidos
            </div>
            <div class="quadros_numeros_porcentagem">
              {{ porcentagemPedidos | currency: 'BRL' : '' }}%
            </div>
          </div>
        </div>
        <!-- Pedidos (Valor) -->
        <div class="quadros_numeros_sm p-2">
          <div class="d-flex align-items-center">
            <div class="pl-2 pr-2">
              <i class="fa fa-dollar quadros_numeros_icones"></i>
            </div>
            <div class="quadros_numeros_textos">
              {{ valorPedidos | currency: 'BRL' }}<br />Pedidos Total
            </div>
          </div>
        </div>
        <!-- Litragem Total -->
        <div class="quadros_numeros_sm p-2 mr-0">
          <div class="d-flex align-items-center">
            <div class="pl-2 pr-2">
              <i class="fa fa-filter quadros_numeros_icones"></i>
            </div>
            <div class="quadros_numeros_textos">
              {{ litragemTotal | currency: 'BRL' : '' }}<br />Litragem Total
            </div>
          </div>
        </div>
      </div>
      <hr class="mt-2 mb-2" />
      <!-- Acompanhamento da Equipe -->
      <div class="d-flex flex-wrap justify-content-between align-items-center">
        <div class="acompanhamento_equipe">
          <div class="text-center">
            <b>Acompanhamento da Equipe</b>
          </div>
          <div class="acompanhamento_equipe_quadro p-1 mt-3">
            <div class="d-flex justify-content-center align-items-center">
              <div class="acompanhamento_equipe_quadro_circulo p-4 m-2">
                <div class="acompanhamento_equipe_quadro_texto text-center">{{ qtdeComCheckIn }}</div>
                <div class="badge badge-success">Com Check-in</div>
              </div>
              <div class="acompanhamento_equipe_quadro_circulo p-4 m-2">
                <div class="acompanhamento_equipe_quadro_texto text-center">{{ qtdeSemCheckIn }}</div>
                <div class="badge badge-danger">Sem Check-in</div>
              </div>
            </div>
          </div>
        </div>
        <div class="acompanhamento_equipe_tabela flex-grow-1 p-2">
          <div class="table-responsive">
            <cdk-virtual-scroll-viewport class="tabela_md" [itemSize]="20">
              <table class="table table-sm table-hover">
                <thead>
                  <tr>
                    <th>Vendedor(a)</th>
                    <th class="text-center tabela_borda">Status</th>
                    <th class="text-center tabela_borda">Dt. Execução</th>
                    <th class="text-center tabela_borda">1º Check-in</th>
                    <th class="tabela_borda">Nome (Rota)</th>
                    <th class="text-right tabela_borda">Objetivo</th>
                    <th class="text-right tabela_borda">Realizado</th>
                    <th class="text-center tabela_borda">Realizado: %</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *cdkVirtualFor="let primeiraVisita of primeirasVisitas; templateCacheSize: 0;">
                    <td>{{ primeiraVisita.vendedor }}</td>
                    <td class="text-center tabela_borda">
                      @if (primeiraVisita.status == 'Realizado') {
                        <span class="badge badge-success">{{ primeiraVisita.status }}</span>
                      }
                      @if (primeiraVisita.status == 'Pendente') {
                        <span class="badge badge-danger">{{ primeiraVisita.status }}</span>
                      }
                    </td>
                    <td class="text-center tabela_borda">{{ primeiraVisita.dt_execucao | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
                    <td class="text-center tabela_borda">{{ primeiraVisita.primeiro_check_in | date: 'HH:mm:ss' }}</td>
                    <td class="tabela_borda">{{ primeiraVisita.nome }}</td>
                    <td class="text-right tabela_borda">{{ primeiraVisita.obj_faturamento | currency: 'BRL' : '' }}</td>
                    <td class="text-right tabela_borda">{{ primeiraVisita.realizado | currency: 'BRL' : '' }}</td>
                    <td class="text-center tabela_borda">
                      @if (primeiraVisita.porcentagem < 80) {
                        <span class="badge badge-danger">{{ primeiraVisita.porcentagem | currency: 'BRL' : '' }}%</span>
                      }
                      @if (primeiraVisita.porcentagem >= 80 && primeiraVisita.porcentagem <= 100) {
                        <span class="badge badge-warning">{{ primeiraVisita.porcentagem | currency: 'BRL' : '' }}%</span>
                      }
                      @if (primeiraVisita.porcentagem > 100) {
                        <span class="badge badge-success">{{ primeiraVisita.porcentagem | currency: 'BRL' : '' }}%</span>
                      }
                    </td>
                  </tr>
                </tbody>
              </table>
            </cdk-virtual-scroll-viewport>
          </div>
        </div>
      </div>
      <hr class="mt-2 mb-2" />
      <!-- Acompanhamento das Visitas -->
      <div class="d-flex flex-wrap justify-content-between">
        <div class="acompanhamento_visitas flex-grow-1">
          <div class="text-center p-2">
            <b>Acompanhamento das Visitas</b>
          </div>
          <div class="p-2">
            <div class="table-responsive">
              <cdk-virtual-scroll-viewport class="tabela_lg" [itemSize]="20">
                <table class="table table-sm table-hover">
                  <thead>
                    <tr>
                      <th></th>
                      <th class="tabela_borda"></th>
                      <th class="tabela_borda"></th>
                      <th class="tabela_borda">Vendedor(a)</th>
                      <th class="text-center tabela_borda">No Cliente</th>
                      <th class="text-center tabela_borda">Status</th>
                      <th class="text-center tabela_borda">Dt. Rota</th>
                      <th>Rota</th>
                      <th class="tabela_borda">Cliente</th>
                      <th class="text-center tabela_borda">Check-in</th>
                      <th class="text-center">Check-out</th>
                      <th class="text-center">Duração</th>
                      <th class="tabela_borda">Resultado</th>
                    </tr>
                  </thead>
                  <tbody>
                    <ng-container *cdkVirtualFor="let visita of visitas; templateCacheSize: 0;">
                      <tr>
                        <td class="text-center tabela_acao">
                          @if (visita.possui_fotos) {
                            <i class="fa fa-image btn_tabela_acao" placement="right" ngbTooltip="Imagens" (click)="modalImagens(imagens, visita.visit_id_app)"></i>
                          }
                        </td>
                        <td class="text-center tabela_acao tabela_borda">
                          @if (visita.possui_fotos) {
                            <i class="fa fa-file btn_tabela_acao" placement="right" ngbTooltip="PDF" (click)="imprimirImagensVisita(visita.visit_id_app)"></i>
                          }
                        </td>
                        <td class="text-center tabela_acao tabela_borda">
                          @if (visita.check_in != null) {
                            <i class="fa fa-map-marker btn_tabela_acao" placement="right" ngbTooltip="Rotas" (click)="modalRotas(rotas, visita)"></i>
                          }
                        </td>
                        <td class="tabela_borda"><b>{{ visita.vendedor }}</b></td>
                        <td class="text-center tabela_borda">
                          @if ((visita.no_cliente == null || visita.no_cliente == 0) && visita.check_in != null) {
                            <span class="badge badge-success">OK</span>
                          }
                          @if (visita.no_cliente > 0) {
                            <span class="badge badge-danger">{{ visita.no_cliente | number : '1.0-0' }} m</span>
                          }
                        </td>
                        <td class="text-center tabela_borda">
                          @if (visita.status == 'EM ROTA') {
                            <span class="badge badge-success">{{ visita.status }}</span>
                          }
                          @if (visita.status == 'FORA ROTA') {
                            <span class="badge badge-danger">{{ visita.status }}</span>
                          }
                          @if (visita.status == 'NÃO VISITADO') {
                            <span class="badge badge-warning">{{ visita.status }}</span>
                          }
                        </td>
                        <td class="text-center tabela_borda">{{ visita.data_rota | date: 'dd/MM/yyyy' }}</td>
                        <td>{{ visita.rota }}</td>
                        <td class="tabela_borda"><b>{{ visita.client }}</b></td>
                        <td class="text-center tabela_borda">{{ visita.check_in | date: 'HH:mm:ss' }}</td>
                        <td class="text-center">{{ visita.check_out | date: 'HH:mm:ss' }}</td>
                        <td class="text-center">{{ visita.duracao }} @if (visita.duracao != null) {
                          <span>MIN</span>
                        }</td>
                        <td class="tabela_borda">{{ visita.resultado }}</td>
                      </tr>
                      @if (visita.observacao != null && visita.observacao != '') {
                        <tr>
                          <td colspan="8"></td>
                          <td class="tabela_borda" colspan="5">{{ visita.observacao }}</td>
                        </tr>
                      }
                    </ng-container>
                  </tbody>
                </table>
              </cdk-virtual-scroll-viewport>
            </div>
          </div>
          <div class="col-sm-12 text-right p-2">
            <button class="btn btn-link" type="button" (click)="exportarVisitas()">Exportar p/ Excel</button>
          </div>
        </div>
      </div>
      <hr class="mt-2 mb-2" />
      <!-- Estatística (Canal de Vendas) / Detalhamento dos Pedidos -->
      <div class="d-flex quadro_estatistica justify-content-between">
        <div class="estatistica text-center p-2">
          <div>
            <b>Estatística (Canal de Vendas)</b>
          </div>
          <div class="estatistica_quadro mt-3">
            <div class="d-flex flex-column">
              <div class="d-flex justify-content-between pr-2 pb-2 pl-2">
                <div class="estatistica_legenda email mr-3"></div>
                <div class="estatistica_legenda_descricao text-left">E-mail</div>
                <div class="estatistica_legenda_descricao text-right">{{ valorEmail | currency: 'BRL' }}</div>
                <div class="estatistica_legenda_descricao text-right">{{ porcentagemEmail | currency: 'BRL' : '' }}%</div>
              </div>
              <div class="d-flex justify-content-between pr-2 pb-2 pl-2">
                <div class="estatistica_legenda telefone mr-3"></div>
                <div class="estatistica_legenda_descricao text-left">Telefone</div>
                <div class="estatistica_legenda_descricao text-right">{{ valorTelefone | currency: 'BRL' }}</div>
                <div class="estatistica_legenda_descricao text-right">{{ porcentagemTelefone | currency: 'BRL' : '' }}%</div>
              </div>
              <div class="d-flex justify-content-between pr-2 pb-2 pl-2">
                <div class="estatistica_legenda visita mr-3"></div>
                <div class="estatistica_legenda_descricao text-left">Visita</div>
                <div class="estatistica_legenda_descricao text-right">{{ valorVisita | currency: 'BRL' }}</div>
                <div class="estatistica_legenda_descricao text-right">{{ porcentagemVisita | currency: 'BRL' : '' }}%</div>
              </div>
              <div class="d-flex justify-content-between pr-2 pb-2 pl-2">
                <div class="estatistica_legenda whatsapp mr-3"></div>
                <div class="estatistica_legenda_descricao text-left">WhatsApp</div>
                <div class="estatistica_legenda_descricao text-right">{{ valorWhatsApp | currency: 'BRL' }}</div>
                <div class="estatistica_legenda_descricao text-right">{{ porcentagemWhatsApp | currency: 'BRL' : '' }}%</div>
              </div>
            </div>
          </div>
        </div>
        <div class="detalhamento flex-grow-1">
          <div class="text-center p-2">
            <b>Detalhamento dos Pedidos</b>
          </div>
          <div class="p-2">
            <div class="table-responsive">
              <cdk-virtual-scroll-viewport class="tabela_lg" [itemSize]="20">
                <table class="table table-sm table-hover">
                  <thead>
                    <tr>
                      <th>Vendedor(a)</th>
                      <th class="text-center tabela_borda">Nro Pedido</th>
                      <th class="text-center tabela_borda">Data</th>
                      <th class="tabela_borda">Cliente</th>
                      <th class="tabela_borda">Canal de Vendas</th>
                      <th class="text-right tabela_borda">Pedido: R$</th>
                      <th class="tabela_borda">Prazo de Pagamento</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *cdkVirtualFor="let canalVenda of canaisVendas; templateCacheSize: 0;">
                      <td>{{ canalVenda.vendedor }}</td>
                      <td class="text-center tabela_borda">{{ canalVenda.id_pedido }}</td>
                      <td class="text-center tabela_borda">{{ canalVenda.data_pedido | date: 'dd/MM/yyyy' }}</td>
                      <td class="tabela_borda">{{ canalVenda.cliente }}</td>
                      <td class="estatistica_legenda_tabela_coluna tabela_borda">
                        @if (canalVenda.canal_de_vendas == 'E-mail') {
                          <div class="estatistica_legenda_tabela email"></div>
                          <div class="estatistica_legenda_tabela_descricao">{{ canalVenda.canal_de_vendas }}</div>
                        }
                        @if (canalVenda.canal_de_vendas == 'Telefone') {
                          <div class="estatistica_legenda_tabela telefone"></div>
                          <div class="estatistica_legenda_tabela_descricao">{{ canalVenda.canal_de_vendas }}</div>
                        }
                        @if (canalVenda.canal_de_vendas == 'Visita') {
                          <div class="estatistica_legenda_tabela visita"></div>
                          <div class="estatistica_legenda_tabela_descricao">{{ canalVenda.canal_de_vendas }}</div>
                        }
                        @if (canalVenda.canal_de_vendas == 'WhatsApp') {
                          <div class="estatistica_legenda_tabela whatsapp"></div>
                          <div class="estatistica_legenda_tabela_descricao">{{ canalVenda.canal_de_vendas }}</div>
                        }
                      </td>
                      <td class="text-right tabela_borda">{{ canalVenda.valor_do_pedido | currency: 'BRL' }}</td>
                      <td class="tabela_borda">{{ canalVenda.prazo_pagamento }}</td>
                    </tr>
                  </tbody>
                </table>
              </cdk-virtual-scroll-viewport>
            </div>
          </div>
          <div class="col-sm-12 text-right p-2">
            <button class="btn btn-link" type="button" (click)="exportarPedidos()">Exportar p/ Excel</button>
          </div>
        </div>
      </div>
      <hr class="mt-2 mb-2" />
      <!-- Gráfico de Efetividade das Visitas por Vendedor -->
      <div class="flex-grow-1 grafico_efetividade p-2">
        <div class="text-center pb-2">
          <b>Gráfico de Efetividade das Visitas por Vendedor</b>
        </div>
        <div style="display: block;">
          <canvas baseChart
            [datasets]="barChartData"
            [labels]="barChartLabels"
            [options]="barChartOptions"
            [plugins]="barChartPlugins"
            [legend]="barChartLegend"
            [chartType]="barChartType"
            [colors]="lineChartColors"
            height="350">
          </canvas>
        </div>
      </div>
      <hr class="mt-2 mb-2" />
      <!-- Relatório Sintético de Visitas e Vendas por Vendedor -->
      <div class="d-flex justify-content-between">
        <div class="relatorio_sintetico_visitas flex-grow-1">
          <div class="text-center p-2">
            <b>Relatório Sintético de Visitas e Vendas por Vendedor</b>
          </div>
          <div class="relatorio_sintetico_visitas_tabela p-2">
            <div class="table-responsive">
              <table class="table table-sm table-hover">
                <thead>
                  <tr>
                    <th>Vendedor(a)</th>
                    <th class="text-right tabela_borda">Efetividade: %</th>
                    <th class="text-center tabela_borda">Qtde Visitas</th>
                    <th class="text-center tabela_borda">Em Rota</th>
                    <th class="text-right">%</th>
                    <th class="text-center tabela_borda">Fora de Rota</th>
                    <th class="text-right">%</th>
                    <th class="text-center tabela_borda">Qtde Vendas</th>
                    <th class="text-right">Total Vendas: R$</th>
                    <th class="text-right tabela_borda">Ticket Médio: R$</th>
                  </tr>
                </thead>
                <tbody>
                  @for (visitaSintetica of visitasSinteticas; track visitaSintetica) {
                    <tr>
                      <td>{{ visitaSintetica.vendedor }}</td>
                      <td class="text-right tabela_borda">{{ visitaSintetica.porcentagem_efetividade | currency: 'BRL' : '' }}%</td>
                      <td class="text-center tabela_borda">{{ visitaSintetica.qtde_visitas }}</td>
                      <td class="text-center tabela_borda">{{ visitaSintetica.em_rota }}</td>
                      <td class="text-right">{{ visitaSintetica.porcentagem_em_rota | currency: 'BRL' : '' }}%</td>
                      <td class="text-center tabela_borda">{{ visitaSintetica.fora_rota }}</td>
                      <td class="text-right">{{ visitaSintetica.porcentagem_fora_rota | currency: 'BRL' : '' }}%</td>
                      <td class="text-center tabela_borda">{{ visitaSintetica.qtde_vendas }}</td>
                      <td class="text-right">{{ visitaSintetica.total_vendas | currency: 'BRL' }}</td>
                      <td class="text-right tabela_borda">{{ visitaSintetica.ticket_medio | currency: 'BRL' }}</td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>
          <div class="col-sm-12 text-right p-2">
            <button class="btn btn-link" type="button" (click)="exportarVisitasVendas()">Exportar p/ Excel</button>
          </div>
        </div>
      </div>
    </div>
  </div>
}
